// extracted by mini-css-extract-plugin
export default {"gap-1":"ecGI9","gap-2":"Xub2b","gap-3":"Dk17S","gap-4":"igUBI","gap-5":"KA9c0","gap-6":"kP2uB","gap-7":"fVXy2","gap-8":"frnPJ"};